// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/screens/super_retailer/index.css
// module id = 1863
// module chunks = 0